export const SUPPORTED_LANGUAGES = ["en", "sv"];

export function splitLanguageAndPage(location) {
  if (!location) return [undefined, ""];
  const match = location.match(/(\/(?<language>(en)|(sv)))?(?<path>.*)/);
  return [match.groups.language, match.groups.path || "/"];
}
